export default "__VITE_ASSET__Za$zi9pT__"